import React, { Fragment, PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";

import { SortedListLoading } from "./SortedListLoading";
import { SortedListNoResult } from "./SortedListNoResult";
import { filterResults, paginateResults, sortResults } from "../../../helpers/listHelpers";
import Button from "../../Common/Button";

class SortedList extends PureComponent {
  static propTypes = {
    RowComponent: PropTypes.func.isRequired,
    HeaderComponent: PropTypes.func,
    PaginationComponent: PropTypes.func,
    RowComponentTotals: PropTypes.func,
    UnitsOfMeasureComponent: PropTypes.func,
    className: PropTypes.string,
    currentPage: PropTypes.number,
    data: PropTypes.array,
    headerProps: PropTypes.object,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    itemsByPage: PropTypes.number,
    keyBy: PropTypes.string,
    noResultMessage: PropTypes.string,
    noResultTitle: PropTypes.string,
    onChangePagination: PropTypes.func,
    onChangeSort: PropTypes.func,
    rowProps: PropTypes.object,
    searchQuery: PropTypes.string,
    searchValues: PropTypes.array,
    sort: PropTypes.object,
    sortValues: PropTypes.array
  };

  static defaultProps = {
    HeaderComponent: null,
    PaginationComponent: null,
    RowComponentTotals: null,
    UnitsOfMeasureComponent: null,
    className: "",
    currentPage: 1,
    data: [],
    headerProps: {},
    isLoading: false,
    isMobile: false,
    itemsByPage: 100,
    keyBy: "id",
    noResultMessage: null,
    noResultTitle: null,
    onChangePagination: null,
    onChangeSort: null,
    rowProps: {},
    searchQuery: "",
    searchValues: [],
    sort: {},
    sortValues: []
  };

  state = {
    isFullDataDisplayed: false,
    isHeaderComponentVisible: false
  };

  componentDidMount() {
    if (!this.props.isMobile) {
      this.handleHeaderComponent();
    }
  }

  get firstElement() {
    return (this.props.currentPage - 1) * this.props.itemsByPage;
  }

  get lastElement() {
    return this.props.currentPage * this.props.itemsByPage;
  }

  handleNextPage = dataCount => {
    if (this.lastElement < dataCount) {
      this.sortedListContainerRef.current.scrollLeft = 0;
      this.props.onChangePagination(this.props.currentPage + 1);
    }
  };

  handlePreviousPage = () => {
    if (this.props.currentPage !== 1) {
      this.sortedListContainerRef.current.scrollLeft = 0;
      this.props.onChangePagination(this.props.currentPage - 1);
    }
  };

  handleSortData = keyName => {
    const isSwitchingDirectionNeeded = keyName === this.props.sort.keyName;
    const direction = isSwitchingDirectionNeeded && this.props.sort.direction === "asc" ? "desc" : "asc";

    this.props.onChangeSort({ keyName, direction });
  };

  handleHeaderComponent = () => {
    this.setState({ isHeaderComponentVisible: !this.state.isHeaderComponentVisible });
  };

  handleDisplayFullData = event => {
    event.stopPropagation();
    this.setState({ isFullDataDisplayed: !this.state.isFullDataDisplayed });
  };

  sortedListContainerRef = React.createRef();

  render() {
    const {
      HeaderComponent,
      isMobile,
      PaginationComponent,
      RowComponent,
      RowComponentTotals,
      UnitsOfMeasureComponent,
      className,
      keyBy,
      searchValues,
      sortValues
    } = this.props;
    const { isFullDataDisplayed, isHeaderComponentVisible } = this.state;

    const sortedData = sortResults(this.props.data, sortValues, this.props.sort);
    const filteredData = filterResults(sortedData, searchValues, this.props.searchQuery);
    const paginatedData = paginateResults(filteredData, this.firstElement, this.lastElement);
    const hasNoResult = _.isEmpty(paginatedData) && !this.props.isLoading;

    return (
      <Fragment>
        <div className="sorted-list__container" ref={this.sortedListContainerRef}>
          <section role="table" className={classNames("sorted-list", className, hasNoResult && "--no-result")}>
            {this.props.isLoading && <SortedListLoading />}

            {hasNoResult && (
              <SortedListNoResult title={this.props.noResultTitle} message={this.props.noResultMessage} searchQuery={this.props.searchQuery} />
            )}

            {!_.isEmpty(paginatedData) &&
              !this.props.isLoading && (
                <Fragment>
                  {HeaderComponent &&
                    isMobile && (
                      <Button
                        className={classNames("sorted-list__row-header-toggle", isHeaderComponentVisible && "--close")}
                        icon={isHeaderComponentVisible ? "x" : "sort"}
                        onClick={this.handleHeaderComponent}
                      />
                    )}
                  {HeaderComponent &&
                    isHeaderComponentVisible && (
                      <HeaderComponent isMobile={isMobile} sort={this.props.sort} onClick={this.handleSortData} {...this.props.headerProps} />
                    )}
                  {paginatedData.map(item => (
                    <RowComponent
                      key={_.get(item, keyBy)}
                      item={item}
                      {...this.props.rowProps}
                      isFullDataDisplayed={isFullDataDisplayed}
                      isMobile={isMobile}
                      onDisplayFullData={this.handleDisplayFullData}
                    />
                  ))}
                  {RowComponentTotals && <RowComponentTotals paginatedData={paginatedData} isMobile={isMobile} />}
                </Fragment>
              )}
          </section>
        </div>

        {!_.isEmpty(paginatedData) &&
          PaginationComponent && (
            <PaginationComponent
              currentPage={this.props.currentPage}
              dataCount={_.size(filteredData)}
              firstElement={this.firstElement}
              lastElement={this.lastElement}
              onNextPageClick={this.handleNextPage}
              onPreviousPageClick={this.handlePreviousPage}
            />
          )}

        {UnitsOfMeasureComponent && <UnitsOfMeasureComponent />}
      </Fragment>
    );
  }
}

export default SortedList;



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/SortedList.js